import { render, staticRenderFns } from "./SkeletonInfoCard.vue?vue&type=template&id=4f273945&"
import script from "./SkeletonInfoCard.vue?vue&type=script&lang=js&"
export * from "./SkeletonInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports